import React from "react";
import propEq from "ramda/src/propEq";
import { OptionType } from "@atlaskit/select";

import { useNetwork } from "../../hooks/useNetwork";
import { Select } from "../../UI/Select";
import useAuth from "../../routes/login/AuthContext";

interface IProps {
  subnetwork: number;
  onChange: (value: number) => Promise<any>;
  defaultValue: number;
  isDisabled?: boolean;
}

export const GenderGroupSelect: React.FC<IProps> = (props) => {
  const { getL2, selectedNetwork } = useNetwork();
  const { isSuperAdminRead } = useAuth();
  const [isLoading, setIsLoading] = React.useState(false);
  const [value, setValue] = React.useState<OptionType>();

  const l2 = getL2(selectedNetwork.l1Id, props.subnetwork);
  const genderGroups = l2?.genderNetworkSettingsTransport.genderGroups || [];

  React.useEffect(() => {
    if (value?.value === props.defaultValue) {
      return;
    }

    const defaultValue = genderGroups.find(propEq("id", props.defaultValue));

    if (!defaultValue) return;

    setValue({
      label: defaultValue.name,
      value: defaultValue.id,
    });
  }, [props.defaultValue, value]);

  const handleChange = async (selection: any) => {
    setValue(selection);
    setIsLoading(true);
    await props.onChange(selection?.value);
    setIsLoading(false);
  };

  return (
    <Select
      value={value}
      onChange={handleChange}
      isDisabled={isLoading || isSuperAdminRead() || props.isDisabled}
      options={genderGroups.map((option) => ({
        value: option.id,
        label: option.name,
      }))}
    />
  );
};

GenderGroupSelect.defaultProps = {
  defaultValue: 0,
};
